import { __read, __values } from "tslib";
import { FormErrorMap } from "Login/Decorator/Validator";
export function mapFormErrorMetaData(metaData) {
    var e_1, _a;
    var formErrorMap = new FormErrorMap();
    try {
        for (var _b = __values(metaData.items), _c = _b.next(); !_c.done; _c = _b.next()) {
            var item = _c.value;
            if (!item.fieldName)
                continue;
            formErrorMap.append(item.fieldName).setError(item.message);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return formErrorMap.serialize;
}
export function mapErrorKeys(errorMap, keyMap) {
    var e_2, _a;
    var _b;
    try {
        for (var _c = __values(Object.keys(errorMap)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var errorKey = _d.value;
            if (!keyMap.has(errorKey))
                continue;
            var mapping = keyMap.get(errorKey);
            if (mapping.rule && !mapping.rule(errorMap[errorKey]))
                continue;
            if (!((_b = errorMap[mapping.fieldName]) === null || _b === void 0 ? void 0 : _b.error))
                errorMap[mapping.fieldName] = errorMap[errorKey];
            delete errorMap[errorKey];
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return errorMap;
}
export function extractPasswordRequirements(errorData, key) {
    if (key === void 0) { key = 'password'; }
    if (!errorData[key] || !/.*\/(.*:.*;){3}/.test(errorData[key].message))
        return;
    var _a = __read(errorData[key].message.split('/'), 2), message = _a[0], requirements = _a[1];
    errorData[key].message = message;
    return requirements.split(';').map(function (data) {
        var _a = __read(data.split(':'), 2), valid = _a[0], message = _a[1];
        return {
            valid: JSON.parse(valid),
            message: message
        };
    });
}
var Serializable = /** @class */ (function () {
    function Serializable() {
        Object.defineProperty(this, "serialID", { set: function (_) { } });
    }
    Serializable.prototype.deserialize = function (target) {
        var _this = this;
        Object.keys(target).forEach(function (key) {
            var self = _this;
            if (self[key] && self[key] instanceof Serializable)
                self[key].deserialize(target[key]);
            else
                _this[key] = target[key];
        });
    };
    Serializable.fromJSON = function (json, target) {
        var obj = new target();
        obj.deserialize(target);
        return obj;
    };
    return Serializable;
}());
export { Serializable };
